import { Component, OnInit, inject } from '@angular/core';
import { RiskScoringService } from 'src/app/services/risk-scoring.service';
import { MessageService } from 'primeng/api';
import { AuthService } from 'src/app/services/auth.service';
import { AccountManagementService } from '../services/account-management.service';
import { ILogger, LOGGER_TOKEN } from 'src/app/services/logger/ilogger';

@Component({
    selector: 'app-risk-scoring',
    templateUrl: './risk-scoring.component.html',
    styleUrls: ['./risk-scoring.component.css'],
    standalone: false
})
export class RiskScoringComponent implements OnInit {
  private readonly logger = inject<ILogger>(LOGGER_TOKEN);
  private riskScoringService = inject(RiskScoringService);
  private messageService = inject(MessageService);
  private authService = inject(AuthService);
  private accountManagementService = inject(AccountManagementService);

  cols!: any[];
  records: any[] = [];
  totalCount: any = 0;
  regionOptions: any[] = [];
  campusOptions: any[] = [];
  scope: any = {
    condition: [],
    icon: null,
    serviceGroup: null,
    regionId: null,
    campusId: null,
    criteria: null,
  }

  campus : any = {};
  risk_scoring_id!: string | null
  isValid!: boolean
  riskScoringAddUpdate = false;
  crieteria_types: any[] = [];
  showCampus = false;
  icon_types: any[] = [];

  ngOnInit(): void {
    this.cols = [
      { field: 'condition', header: 'Condition' },
      { field: 'icon', header: 'Icon' },
      // { field: 'regionId', header:'Region'},
      // { field: 'campusId', header:'Campus'},
      { field: 'Actions', header: 'Actions' },
    ];
    this.crieteria_types = [
      {label:"Select", value:""},
      {label:"Region", value:"region"},
      {label:"Campus", value:"campus"},
    ]
    const body = document.getElementsByTagName('body')[0];
    body.className = "";
    this.updateRiskScoringList();
    this.loadRegionOptions();
    body.classList.add('subpage');
    this.icon_types = [
      {label:"Select"},
      {label:"Green White", value:"green_white"},
      {label:"Green", value:"green"},
      {label:"Yellow", value:"yellow"},
      {label:"Red", value:"red"},
      {label:"Red White", value:"red_white"}
      
    ];
  }

  loadRecordsLazy(event: any) {
    this.riskScoringService.getkeyValueList(event["first"]).subscribe(
      (res) => {
        this.totalCount = (res as any)["count"];
        this.records = (res as any)["docs"];
      }, (err) => {
        this.logger.exception(err)
      }
    );
  }

  showUpdateriskScoring(riskScore: any){
    this.messageService.clear();
    this.risk_scoring_id = riskScore._id;
    this.scope.condition = riskScore.condition;
    this.scope.icon = riskScore.icon;
    this.scope.serviceGroup = riskScore.serviceGroup;
   
    this.scope.criteria = riskScore.criteria;
    this.scope.regionId = riskScore.regionId
    this.riskScoringAddUpdate = true;
   this.onRegionChanged();
    this.checkCrieteria();
    this.scope.campusId = riskScore.campusId;
  }

  deleteriskScoring(row: any){
    if (confirm("Are you sure that you want to Delete this?")){
      this.riskScoringService.deleteRiskScoring(row._id).subscribe(() => {
        this.updateRiskScoringList();
        const message = {
          severity: 'error', sticky: true,
          summary: "Deleted Successfully",
          detail: '',
        }
        this.messageService.add(message);
        this.updateRiskScoringList();
      });
    }
  }

  updateRiskScoringList() {
    const obj = {};
    (obj as any)["first"] = 0;
    this.loadRecordsLazy(obj)
  }

  submitriskScoring(){
    this.riskScoringService.saveRiskScoring(this.scope, this.risk_scoring_id).subscribe(() => {
      const messageText=(this.risk_scoring_id==null)?"Risk Scoring Saved Successfully":"Risk Scoring Updated Successfully";
      this.updateRiskScoringList();
      this.scope.condition = []
      this.scope.icon = null
      this.risk_scoring_id = null
      const message = {
        severity: 'success', sticky: true,
        summary: messageText,
        detail: '',
      }
      this.messageService.add(message);
    })
  }

  validateForm(){
    if (this.scope.condition != null && this.scope.icon != null) {
      this.isValid = true;
    } else {
      this.isValid = false;
    }
  }
  onServiceGrpChanged(event: any){
    this.scope.serviceGroup = event.serviceGroup;
  }

  addCondition(){
    this.scope.condition.push([]);
  }

  removeCondition(i: number){
    this.scope.condition.splice(i, 2);
  }

  loadRegionOptions(){
     this.accountManagementService.getRegions().subscribe((res) => {
      this.scope.regions = res;
      this.regionOptions = [{ label: "Default", value: "All" }].concat(
        res
      );
    });
    this.loadCampusOptions();
    return this.regionOptions;
  }
  checkCrieteria(){
    if(this.scope.criteria == "campus"){
      this.showCampus = true;
    } else {
      this.showCampus = false;
    }
  }

  loadCampusOptions(){
    this.campusOptions = [{label:"Default",value:"All"}].concat(this.authService.user.campuses.filter((campus: any)=>this.scope.regionId&&this.scope.regionId!='All'?this.scope.regionId==campus.region:true).map((campus: any) =>{
      return {label:campus.label, value:campus._id};
    }))

    const region = this.scope.regions;
    this.accountManagementService.getDefaultCampusesFromRegionId(region).subscribe((
      ) => {
        //this.campus[region.label] = [{ label: "Default Campus", value: "All" }].concat(res);
      }
    );
    return this.campusOptions;
  }
  showConfigAdd(){
    this.messageService.clear()
    this.risk_scoring_id = null;
    this.scope.condition = [];
    this.scope.icon = null;
    this.scope.regionId = 'All';
    this.scope.campus = 'All';
    this.scope.criteria = null;
    this.loadRegionOptions();
    this.checkCrieteria();
    this.addCondition();
    this.riskScoringAddUpdate = true;
  }
  onRegionChanged(){
    this.scope.campusId = "All";
    this.loadCampusOptions();
  }
}
